export default __webpack_public_path__ + "static/media/building.8a9a16e3.png";